import axiosInstance from "../api/axiosInstance";
import type { EHRSyncRunResponse, StartEHRSyncResponse } from "../types/index.type";

const EHR_SYNC_PATH = "/rpa/ehr/sync/";

// 202 with the run id. Re-posting while a run is in flight returns that run's id,
// so a duplicate click attaches to the existing run instead of starting a second.
export const startEHRSync = () => {
  return axiosInstance.post<StartEHRSyncResponse>(EHR_SYNC_PATH);
};

export const getEHRSyncRun = (runId: string) => {
  return axiosInstance.get<EHRSyncRunResponse>(`${EHR_SYNC_PATH}${runId}/`);
};
